'use strict';

var callBind = require('call-bind-apply-helpers');

var gOPD = require('gopd');

var hasProtoAccessor;

try {
  // eslint-disable-next-line no-extra-parens, no-proto
  hasProtoAccessor =
  /** @type {{ __proto__?: typeof Array.prototype }} */
  [].__proto__ === Array.prototype;
} catch (e) {
  if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') {
    throw e;
  }
} // eslint-disable-next-line no-extra-parens


var desc = !!hasProtoAccessor && gOPD && gOPD(Object.prototype,
/** @type {keyof typeof Object.prototype} */
'__proto__');
var $Object = Object;
var $getPrototypeOf = $Object.getPrototypeOf;
/** @type {import('./get')} */

module.exports = desc && typeof desc.get === 'function' ? callBind([desc.get]) : typeof $getPrototypeOf === 'function' ?
/** @type {import('./get')} */
function getDunder(value) {
  // eslint-disable-next-line eqeqeq
  return $getPrototypeOf(value == null ? value : $Object(value));
} : false;